export default __webpack_public_path__ + "static/media/move_to_inbox_black_24dp.1be5d0d9.svg";